import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { Fragment } from 'react'
import { X } from 'lucide-react'
import useModal from "../../hooks/useModal";
import { Button, Text } from '@oc-labs/wt-storybook'

export default function VerticalDrawer({ name, children, className, title = "Unknown" }) {
  const drawer = useModal(name)

  return (
    <Transition show={drawer.isOpen} as={Fragment}>
      <Dialog 
        onClose={drawer.close} 
        className="fixed inset-0 z-[110] overflow-hidden"
      >
        <div className="absolute inset-0 bg-black/40" aria-hidden="true" onClick={drawer.close} />

        <div className="fixed inset-y-0 right-0 flex max-w-full">
          <TransitionChild
            as={Fragment}
            enter="transform transition ease-in-out duration-500"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in-out duration-500"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <DialogPanel className="w-80 sm:w-96 h-full bg-white shadow-xl flex flex-col">
              {/* Header */}
              <div className="px-4 sm:px-6 sticky top-0 bg-white z-10 flex justify-between items-center h-16">
                <Text className="text-xl font-bold">{title}</Text>

                {/* Botón circular personalizado */}
                <button
                  onClick={drawer.close}
                  className="h-8 w-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition"
                >
                  <X className="h-4 w-4 text-gray-700" />
                </button>
              </div>

              {/* Content */}
              <div className={`relative flex-1 px-4 sm:px-6 overflow-y-auto ${className || ''}`}>
                {children}
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
